var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "no-activities-card d-block position-relative",
      style: { height: _vm.arHeight + "px", width: _vm.arWidth + "px" },
      attrs: { href: _vm.href }
    },
    [
      _c(
        "div",
        {
          staticClass: " w-100 h-100",
          style: { "padding-top": (_vm.arHeight / _vm.arWidth) * 100 + "%" }
        },
        [
          _c("div", { staticClass: "bg" }, [
            _c("div", { staticClass: "plus-icon mb-16" }),
            _vm._v(" "),
            _c("span", { staticClass: "text" }, [_vm._v(_vm._s(_vm.text))])
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }